export type TClient = {
  id: number;
  uuid: string;
  nickname: string;
  phone: string;
  last_client_activity: string;
  user_discount: number;
  group: GroupTitle | null;
  deposit: number;
  bonus: number;
  banned_at: string | null;
  created_at: string;
  unverified: boolean;
  avatar_url: string;
  roles: Array<{
    alias: string;
  }>;
};

export enum ESortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type GroupTitle = {
  uuid: string;
  title: string;
  discount: number;
};

export type UserGroup = GroupTitle & {
  user_count: number;
  created_at: string;
};

export type TClientsPageOpenTab = 'clients' | 'groups';
